import { DeleteIcon } from '@vlabs/icons';
import { permissions } from '@vlabs/shared/config';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';

import { deleteFaceHandler } from './ui/deleteFaceHandler';

interface DeleteFaceButtonProps extends WithDataTestid {
  faceId: string;
  onSuccess?: VoidFunction;
}

export function DeleteFaceButton({
  faceId,
  onSuccess = undefined,
  'data-testid': dataTestId = 'deleteFaceButton',
  ...buttonProps
}: DeleteFaceButtonProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <ButtonWithPermissions
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={deleteFaceHandler({ faceId, onSuccess })}
      permissions={{ rules: [permissions.face.deletion], method: 'oneof' }}
      size="small"
      variant="flat"
      {...buttonProps}
    >
      {t('features:deleteFace.btn.delete_face')}
    </ButtonWithPermissions>
  );
}
